export default __webpack_public_path__ + "static/media/flagng.e7b0182e.svg";